import { WorkorderChecklistItemType } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import { RouteType } from '@/types/RouteType';

// const boschChecklistRoutes = [
//   'requestedServices',
//   'quickChecklist',
//   'complementItems',
// ];

export default function useChecklistValidRoutes({
  route,
  ...params
}: {
  route: RouteType;
  checklistItemType?: WorkorderChecklistItemType;
  workorderId?: number;
  boschChecklist?: boolean;
}): RouteType {
  if (params.checklistItemType === WorkorderChecklistItemType.Diagnostic) {
    const routes = route.parent.routes.filter(
      (item) => item.key !== 'futureServices',
    );

    // if (!params.boschChecklist) {
    //   routes = routes.filter(
    //     (item) => !boschChecklistRoutes.includes(item.key),
    //   );
    // }

    return {
      ...route.parent,
      routes,
    };
  }

  return route.parent;

  // if (params.boschChecklist) {
  //   return route.parent;
  // } else {
  //   return {
  //     ...route.parent,
  //     routes: route.parent.routes.filter(
  //       (item) => !boschChecklistRoutes.includes(item.key),
  //     ),
  //   };
  // }
}
